import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c0ff124"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_note_body",
  ref: "newTargetModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_3 = { class: "modal-content rounded" }
const _hoisted_4 = { class: "modal-header pb-0 border-0 justify-content-end" }
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = {
  key: 0,
  class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15"
}
const _hoisted_8 = { class: "row gx-5 gy-5" }
const _hoisted_9 = { class: "col-md-4 border-end border-end-dashed bg-body" }
const _hoisted_10 = { class: "d-flex align-items-center mb-3" }
const _hoisted_11 = { class: "d-flex align-items-center flex-grow-1" }
const _hoisted_12 = { class: "symbol symbol-45px me-5" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "d-flex flex-column" }
const _hoisted_15 = { class: "text-gray-700 text-hover-primary fw-bolder" }
const _hoisted_16 = { class: "text-gray-400 fw-bold fs-7" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator mb-4" }, null, -1))
const _hoisted_18 = { class: "d-flex flex-column align-items-start" }
const _hoisted_19 = { class: "d-flex flex-column justify-content-end p-3 border-bottom border-bottom-dashed w-100 mb-5" }
const _hoisted_20 = { class: "d-flex justify-content-between align-items-center mb-1 fs-7 text-gray-600" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 fs-6 fw-light" }, "ادمین", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-fill" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "symbol symbol-circle symbol-35px" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "d-flex flex-column flex-fill text-end me-2" }
const _hoisted_27 = { class: "text-gray-700 text-hover-primary" }
const _hoisted_28 = {
  class: "text-gray-400 fw-light fs-8",
  style: {"direction":"ltr"}
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "d-flex flex-column justify-content-end p-3 border-bottom border-bottom-dashed w-100 mb-5" }
const _hoisted_33 = { class: "d-flex justify-content-between align-items-center mb-1 fs-7 text-gray-600" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 fs-6 fw-light" }, "مشتری", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-fill" }, null, -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_38 = { class: "d-flex align-items-center flex-grow-1 mb-2" }
const _hoisted_39 = { class: "d-flex flex-column flex-fill text-end me-2" }
const _hoisted_40 = { class: "text-gray-700 text-hover-primary" }
const _hoisted_41 = {
  class: "text-gray-400 fw-light fs-8",
  style: {"direction":"ltr"}
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-icon w-20px h-20px" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" })
], -1))
const _hoisted_43 = ["href"]
const _hoisted_44 = { class: "svg-icon svg-icon-3" }
const _hoisted_45 = { class: "d-flex flex-column justify-content-end p-3 border-bottom border-bottom-dashed w-100 mb-5" }
const _hoisted_46 = { class: "d-flex justify-content-between align-items-center mb-1 fs-7 text-gray-600" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 fs-6 fw-light" }, "یادآور", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-sm btn-icon btn-bg-light w-30px h-30px btn-hover-rise" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-fill" })
], -1))
const _hoisted_49 = {
  class: "demo-rich-conent",
  style: {"display":"flex","gap":"16px","flex-direction":"column"}
}
const _hoisted_50 = { class: "d-flex justify-content-between align-items-center mb-1 fs-7 text-gray-600" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "یادآور", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1))
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times text-danger" }, null, -1))
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = {
  key: 0,
  class: "d-flex flex-column flex-nowrap"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bell" }, null, -1))
const _hoisted_60 = { class: "d-flex flex-column justify-content-end p-3 border-bottom border-bottom-dashed w-100 mb-5" }
const _hoisted_61 = { class: "d-flex justify-content-between align-items-center mb-1 fs-7 text-gray-600" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 fs-6 fw-light" }, "برچسب", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-fill" }, null, -1))
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = { class: "d-flex flex-column flex-nowrap" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-tag" }, null, -1))
const _hoisted_67 = { class: "d-flex flex-column justify-content-end p-3 border-bottom border-bottom-dashed w-100 mb-5" }
const _hoisted_68 = { class: "d-flex justify-content-between align-items-center mb-1 fs-7 text-gray-600" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 fs-6 fw-light" }, "پلتفرم", -1))
const _hoisted_70 = { class: "badge badge-white m-2" }
const _hoisted_71 = {
  key: 0,
  class: "symbol-group symbol-hover flex-nowrap"
}
const _hoisted_72 = ["src"]
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-fill" }, null, -1))
const _hoisted_74 = [
  _hoisted_73
]
const _hoisted_75 = { class: "d-flex flex-column justify-content-end p-3 border-bottom border-bottom-dashed w-100 mb-5" }
const _hoisted_76 = { class: "d-flex justify-content-between align-items-center mb-1 fs-7 text-gray-600" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 fs-6 fw-light" }, [
  /*#__PURE__*/_createTextVNode(" مدت زمان "),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-8" }, " دقیقه ")
], -1))
const _hoisted_78 = { class: "badge badge-white m-2" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-fill" }, null, -1))
const _hoisted_80 = [
  _hoisted_79
]
const _hoisted_81 = { class: "d-flex flex-column justify-content-end p-3 border-bottom border-bottom-dashed w-100 mb-5" }
const _hoisted_82 = { class: "d-flex justify-content-between align-items-center mb-1 fs-7 text-gray-600" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 fs-6 fw-light" }, "تصویر", -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1))
const _hoisted_85 = [
  _hoisted_84
]
const _hoisted_86 = {
  key: 0,
  class: ""
}
const _hoisted_87 = ["src"]
const _hoisted_88 = { class: "col-md-8" }
const _hoisted_89 = { class: "mb-7" }
const _hoisted_90 = { class: "fs-3 fw-bold text-dark mb-5" }
const _hoisted_91 = {
  key: 0,
  class: "separator mb-4"
}
const _hoisted_92 = { class: "mb-7 ps-10" }
const _hoisted_93 = { class: "symbol symbol-45px me-5" }
const _hoisted_94 = ["src"]
const _hoisted_95 = { class: "d-flex flex-column flex-row-fluid" }
const _hoisted_96 = { class: "d-flex align-items-center flex-wrap mb-1" }
const _hoisted_97 = { class: "text-gray-800 text-hover-primary fw-bolder me-2" }
const _hoisted_98 = { class: "text-gray-400 fw-bold fs-7" }
const _hoisted_99 = { class: "text-gray-800 fs-7 fw-normal pt-1" }
const _hoisted_100 = { key: 0 }
const _hoisted_101 = ["href"]
const _hoisted_102 = { class: "svg-icon svg-icon-3" }
const _hoisted_103 = /*#__PURE__*/_createTextVNode(" مشاهده فایل ")
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator mb-4" }, null, -1))
const _hoisted_105 = { class: "d-flex" }
const _hoisted_106 = { class: "me-3 d-flex align-items-center" }
const _hoisted_107 = {
  ref: "submitButton",
  type: "submit",
  id: "kt_modal_new_card_submit",
  class: "btn btn-sm btn-primary mt-2"
}
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " ثبت نظر ", -1))
const _hoisted_109 = { class: "indicator-progress" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex mb-1 fs-7 text-gray-600" }, [
  /*#__PURE__*/_createElementVNode("span", null, "اشتراک گذاری با ادمین:")
], -1))
const _hoisted_112 = { class: "d-flex align-items-center" }
const _hoisted_113 = { class: "symbol symbol-20px symbol-circle me-5" }
const _hoisted_114 = ["src"]
const _hoisted_115 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_116 = { class: "mb-1 fs-7" }
const _hoisted_117 = {
  class: "text-grey-500",
  dir: "ltr"
}
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex mb-1 fs-7 text-gray-600" }, [
  /*#__PURE__*/_createElementVNode("span", null, "مشتریان هدف:")
], -1))
const _hoisted_119 = { class: "d-flex align-items-center" }
const _hoisted_120 = { class: "symbol symbol-20px symbol-circle me-5" }
const _hoisted_121 = ["src"]
const _hoisted_122 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_123 = { class: "mb-1 fs-7" }
const _hoisted_124 = {
  class: "text-grey-500",
  dir: "ltr"
}
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex mb-1 fs-7 text-gray-600" }, [
  /*#__PURE__*/_createElementVNode("span", null, "برچسب ها:")
], -1))
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex mb-1 fs-7 text-gray-600" }, [
  /*#__PURE__*/_createElementVNode("span", null, "پلتفرم:")
], -1))
const _hoisted_127 = { class: "d-flex flex-column" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex mb-1 fs-7 text-gray-600" }, [
  /*#__PURE__*/_createElementVNode("span", null, "مدت زمان (دقیقه) :")
], -1))
const _hoisted_129 = { class: "mt-5 d-flex" }
const _hoisted_130 = /*#__PURE__*/_createTextVNode("ذخیره")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Date = _resolveComponent("Date")!
  const _component_UserAvatar = _resolveComponent("UserAvatar")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_UploadData = _resolveComponent("UploadData")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_List = _resolveComponent("List")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        (_ctx.targetTodo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("img", {
                          src: _ctx.targetTodo.creator.picture,
                          alt: ""
                        }, null, 8, _hoisted_13)
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.targetTodo.creator.first_name +
                      " " +
                      _ctx.targetTodo.creator.last_name), 1),
                        _createElementVNode("span", _hoisted_16, [
                          _createVNode(_component_Date, {
                            date: _ctx.targetTodo.created_at
                          }, null, 8, ["date"])
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("label", _hoisted_20, [
                        _hoisted_21,
                        (_ctx.targetTodo.editable)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogVisible = true)),
                              class: "btn btn-sm btn-icon btn-bg-light w-30px h-30px btn-hover-rise"
                            }, _hoisted_23))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targetTodo.assign_admins, (admin, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: i,
                            class: "d-flex align-items-center flex-grow-1 mb-2"
                          }, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("img", {
                                src: admin.picture,
                                alt: ""
                              }, null, 8, _hoisted_25)
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("span", _hoisted_27, _toDisplayString(admin.first_name + " " + admin.last_name), 1),
                              _createElementVNode("span", _hoisted_28, _toDisplayString(admin.mobile), 1)
                            ]),
                            (_ctx.targetTodo.editable)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.removeUser('assign_admins', admin.id)),
                                  class: "btn btn-icon w-20px h-20px"
                                }, _hoisted_31, 8, _hoisted_29))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("label", _hoisted_33, [
                        _hoisted_34,
                        (_ctx.targetTodo.editable)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible2 = true)),
                              class: "btn btn-sm btn-icon btn-bg-light w-30px h-30px btn-hover-rise"
                            }, _hoisted_36))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.targetTodo.customers_count > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targetTodo.for_customers, (customer, j) => {
                              return (_openBlock(), _createElementBlock("div", { key: j }, [
                                _createElementVNode("div", _hoisted_38, [
                                  _createVNode(_component_UserAvatar, {
                                    avatar: customer.picture,
                                    size: "35px",
                                    id: customer.id
                                  }, null, 8, ["avatar", "id"]),
                                  _createElementVNode("div", _hoisted_39, [
                                    _createElementVNode("span", _hoisted_40, _toDisplayString(customer.first_name + " " + customer.last_name), 1),
                                    _createElementVNode("span", _hoisted_41, _toDisplayString(customer.mobile), 1)
                                  ]),
                                  (_ctx.targetTodo.editable)
                                    ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                                        key: 0,
                                        "confirm-button-text": _ctx.translate('yes'),
                                        "cancel-button-text": _ctx.translate('cancel'),
                                        "icon-color": "#626AEF",
                                        title: 
                            _ctx.translate('Are you sure you want to delete this')
                          ,
                                        onConfirm: ($event: any) => (_ctx.removeUser('for_customers', customer.id))
                                      }, {
                                        reference: _withCtx(() => [
                                          _hoisted_42
                                        ]),
                                        _: 2
                                      }, 1032, ["confirm-button-text", "cancel-button-text", "title", "onConfirm"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_el_tooltip, {
                                    content: "جزئیات",
                                    placement: "top",
                                    effect: "dark"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("a", {
                                        href: `/management/users/${customer.id}/history`,
                                        target: "_blank",
                                        class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                                      }, [
                                        _createElementVNode("span", _hoisted_44, [
                                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/technology/teh002.svg" })
                                        ])
                                      ], 8, _hoisted_43)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("label", _hoisted_46, [
                        _hoisted_47,
                        (_ctx.targetTodo.editable)
                          ? (_openBlock(), _createBlock(_component_el_popover, {
                              key: 0,
                              width: "300px"
                            }, {
                              reference: _withCtx(() => [
                                _hoisted_48
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_49, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("label", _hoisted_50, [
                                      _hoisted_51,
                                      (_ctx.targetTodo.editable)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addToReminder())),
                                            class: "btn btn-sm btn-icon btn-primary w-30px h-30px",
                                            style: {"margin-right":"5px"}
                                          }, _hoisted_53))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newNote.setting
                                .reminders, (reminder, index) => {
                                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                                        _createElementVNode("div", _hoisted_54, [
                                          _createVNode(_component_date_picker, {
                                            modelValue: _ctx.newNote.setting.reminders[index],
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.newNote.setting.reminders[index]) = $event),
                                            type: "datetime",
                                            "compact-time": "",
                                            clearable: "",
                                            "auto-submit": "",
                                            "initial-value": 
                                    _ctx.newNote.setting.reminders[index]
                                  ,
                                            locale: _ctx.getLocale(),
                                            format: "YYYY-MM-DD HH:mm",
                                            "display-format": "dddd jDD jMMMM jYYYY HH:mm",
                                            class: "flex-fill",
                                            "jump-minute": 15,
                                            "round-minute": true
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "initial-value", "locale"]),
                                          (_ctx.targetTodo.editable)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                onClick: ($event: any) => (_ctx.removeFromReminder(index)),
                                                class: "btn btn-sm btn-icon btn-light w-30px h-30px",
                                                style: {"margin-right":"5px"}
                                              }, _hoisted_57, 8, _hoisted_55))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      (
                      _ctx.targetTodo.setting.reminders &&
                      _ctx.targetTodo.setting.reminders.length > 0
                    )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targetTodo.setting.reminders, (reminder, j) => {
                              return (_openBlock(), _createElementBlock("span", {
                                class: "badge badge-white m-2",
                                key: j
                              }, [
                                _hoisted_59,
                                _createTextVNode(" " + _toDisplayString(reminder), 1)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("label", _hoisted_61, [
                        _hoisted_62,
                        (_ctx.targetTodo.editable)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogVisible3 = true)),
                              class: "btn btn-sm btn-icon btn-bg-light w-30px h-30px btn-hover-rise"
                            }, _hoisted_64))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_65, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targetTodo.tags, (tag, j) => {
                          return (_openBlock(), _createElementBlock("span", {
                            class: "badge badge-white m-2",
                            key: j
                          }, [
                            _hoisted_66,
                            _createTextVNode(" " + _toDisplayString(tag), 1)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("label", _hoisted_68, [
                        _hoisted_69,
                        _createElementVNode("span", _hoisted_70, [
                          (_ctx.targetTodo.platforms !== null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targetTodo.platforms, (plat, p) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "symbol symbol-20px symbol-circle",
                                    style: {"margin-right":"2px !important"},
                                    key: p
                                  }, [
                                    _createElementVNode("img", {
                                      alt: "Pic",
                                      src: _ctx.platformsList[plat]?.logo
                                    }, null, 8, _hoisted_72)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.targetTodo.editable)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogVisible4 = true)),
                              class: "btn btn-sm btn-icon btn-bg-light w-30px h-30px btn-hover-rise"
                            }, _hoisted_74))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("label", _hoisted_76, [
                        _hoisted_77,
                        _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.targetTodo.duration), 1),
                        (_ctx.targetTodo.editable)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.dialogVisible5 = true)),
                              class: "btn btn-sm btn-icon btn-bg-light w-30px h-30px btn-hover-rise"
                            }, _hoisted_80))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_81, [
                      _createElementVNode("label", _hoisted_82, [
                        _hoisted_83,
                        (_ctx.targetTodo.editable)
                          ? (_openBlock(), _createBlock(_component_UploadData, {
                              key: 0,
                              onUploading: _ctx.checkFileInUploading,
                              disabled: _ctx.comment.status,
                              url: "upload/file",
                              title: "select file",
                              onUploadSuccess: _ctx.fileUploadedCallBack2
                            }, null, 8, ["onUploading", "disabled", "onUploadSuccess"]))
                          : _createCommentVNode("", true),
                        (_ctx.targetTodo.editable)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (
                        (_ctx.newNote.remove_thumbnail = true), _ctx.updateTodo(_ctx.newNote)
                      )),
                              class: "btn btn-icon w-20px h-20px btn-light-danger"
                            }, _hoisted_85))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.targetTodo.thumbnail)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                            _createElementVNode("img", {
                              src: _ctx.targetTodo.thumbnail,
                              class: "img-fluid img-thumbnail"
                            }, null, 8, _hoisted_87)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_88, [
                  _createElementVNode("div", _hoisted_89, [
                    _createElementVNode("div", _hoisted_90, [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        placeholder: "عنوان ...",
                        autosize: { minRows: 1, maxRows: 4 },
                        name: "title",
                        class: "flex-fill",
                        modelValue: _ctx.newNote.title,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newNote.title) = $event)),
                        onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateTodo(_ctx.newNote))),
                        disabled: !_ctx.targetTodo.editable
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.newNote.description,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newNote.description) = $event)),
                      class: "mb-5",
                      autosize: { minRows: 2, maxRows: 4 },
                      type: "textarea",
                      placeholder: "توضیحات ...",
                      onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateTodo(_ctx.newNote))),
                      disabled: !_ctx.targetTodo.editable
                    }, null, 8, ["modelValue", "disabled"]),
                    (_openBlock(), _createBlock(_component_List, {
                      key: _ctx.targetTodo.id,
                      listData: _ctx.newNote.todo_list,
                      onUpdate: _ctx.updateTodoList,
                      editable: _ctx.targetTodo.editable
                    }, null, 8, ["listData", "onUpdate", "editable"]))
                  ]),
                  (_ctx.comments)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_91))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_92, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comments, (comment, j) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: j,
                        class: "d-flex mb-5"
                      }, [
                        _createElementVNode("div", _hoisted_93, [
                          _createElementVNode("img", {
                            src: comment.user.picture,
                            alt: ""
                          }, null, 8, _hoisted_94)
                        ]),
                        _createElementVNode("div", _hoisted_95, [
                          _createElementVNode("div", _hoisted_96, [
                            _createElementVNode("div", _hoisted_97, _toDisplayString(comment.full_name), 1),
                            _createElementVNode("span", _hoisted_98, [
                              (comment.send_at)
                                ? (_openBlock(), _createBlock(_component_Date, {
                                    key: 0,
                                    type: "human",
                                    date: comment.send_at
                                  }, null, 8, ["date"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("span", _hoisted_99, [
                            _createTextVNode(_toDisplayString(comment.comment) + " ", 1),
                            (comment.file)
                              ? (_openBlock(), _createElementBlock("br", _hoisted_100))
                              : _createCommentVNode("", true),
                            (comment.file)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  href: comment.file,
                                  target: "_blank",
                                  class: "btn btn-sm btn-active-color-primary pe-0 m-1 text-nowrap fs-7"
                                }, [
                                  _createElementVNode("span", _hoisted_102, [
                                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/communication/com008.svg" })
                                  ]),
                                  _hoisted_103
                                ], 8, _hoisted_101))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    }), 128))
                  ]),
                  _hoisted_104,
                  _createElementVNode("form", {
                    onSubmit: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendTaskComments && _ctx.sendTaskComments(...args)), ["prevent"])),
                    class: "position-relative mb-6 d-flex flex-column"
                  }, [
                    _createElementVNode("div", _hoisted_105, [
                      _createVNode(_component_el_input, {
                        style: {"margin-left":"5px"},
                        modelValue: _ctx.comment.comment,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.comment.comment) = $event)),
                        autosize: "",
                        type: "textarea",
                        class: "flex-fill",
                        placeholder: "ارسال نظر ..."
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_UploadData, {
                        onUploading: _ctx.checkFileInUploading,
                        disabled: _ctx.comment.status,
                        url: "upload/file",
                        title: "select file",
                        onUploadSuccess: _ctx.fileUploadedCallBack
                      }, null, 8, ["onUploading", "disabled", "onUploadSuccess"])
                    ]),
                    _createElementVNode("div", _hoisted_106, [
                      _createElementVNode("button", _hoisted_107, [
                        _hoisted_108,
                        _createElementVNode("span", _hoisted_109, [
                          _createTextVNode(_toDisplayString(_ctx.translate("please wait")) + " ", 1),
                          _hoisted_110
                        ])
                      ], 512)
                    ])
                  ], 32)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      width: "250px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_111,
          _createVNode(_component_el_select, {
            size: "small",
            multiple: "",
            filterable: "",
            remote: "",
            "reserve-keyword": "",
            modelValue: _ctx.newNote.holder.assign_admins,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newNote.holder.assign_admins) = $event)),
            placeholder: "جستجوی کاربر",
            loading: _ctx.loadingSearchUser,
            "loading-text": "در حال جستجو ...",
            "remote-method": _ctx.performSearch,
            onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.checkAddNew('assign_admins'))),
            id: "searchAdmin"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.admins, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.full_name,
                  value: item.id
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_112, [
                      _createElementVNode("div", _hoisted_113, [
                        _createElementVNode("img", {
                          src: item?.picture ?? `media/avatars/blank.png`,
                          alt: ""
                        }, null, 8, _hoisted_114)
                      ]),
                      _createElementVNode("div", _hoisted_115, [
                        _createElementVNode("span", _hoisted_116, [
                          _createTextVNode(_toDisplayString(item?.first_name + " " + item?.last_name) + " ", 1),
                          _createElementVNode("span", _hoisted_117, "( " + _toDisplayString(item?.mobile) + " ) ", 1)
                        ])
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "loading", "remote-method"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible2,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.dialogVisible2) = $event)),
      width: "250px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_118,
          _createVNode(_component_el_select, {
            size: "small",
            multiple: "",
            filterable: "",
            remote: "",
            "reserve-keyword": "",
            modelValue: _ctx.newNote.holder.for_customers,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newNote.holder.for_customers) = $event)),
            placeholder: "جستجوی کاربر",
            loading: _ctx.loadingSearchUser,
            "loading-text": "در حال جستجو ...",
            "remote-method": _ctx.performSearch,
            onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.checkAddNew('for_customers'))),
            id: "searchAdmin"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.full_name,
                  value: item.id
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_119, [
                      _createElementVNode("div", _hoisted_120, [
                        _createElementVNode("img", {
                          src: item?.picture ?? `media/avatars/blank.png`,
                          alt: ""
                        }, null, 8, _hoisted_121)
                      ]),
                      _createElementVNode("div", _hoisted_122, [
                        _createElementVNode("span", _hoisted_123, [
                          _createTextVNode(_toDisplayString(item?.first_name + " " + item?.last_name) + " ", 1),
                          _createElementVNode("span", _hoisted_124, "( " + _toDisplayString(item?.mobile) + " ) ", 1)
                        ])
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "loading", "remote-method"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible3,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.dialogVisible3) = $event)),
      width: "250px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_125,
          _createVNode(_component_el_select, {
            modelValue: _ctx.newNote.tags,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.newNote.tags) = $event)),
            multiple: "",
            filterable: "",
            "allow-create": "",
            "default-first-option": "",
            placeholder: "برچسب",
            remote: "",
            "remote-method": _ctx.TagListSearch,
            "loading-text": "در حال جستجو ...",
            onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.updateTodo(_ctx.newNote)))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.TagList, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.tag,
                  value: item.tag
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "remote-method"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible4,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.dialogVisible4) = $event)),
      width: "250px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_126,
          _createVNode(_component_el_select, {
            modelValue: _ctx.newNote.platforms,
            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.newNote.platforms) = $event)),
            placeholder: "پلتفرم",
            multiple: "",
            "collapse-tags": "",
            onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.updateTodo(_ctx.newNote)))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.platformsList, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: _ctx.translate(index),
                  value: index
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible5,
      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.dialogVisible5) = $event)),
      width: "250px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_127, [
          _hoisted_128,
          _createVNode(_component_el_input, {
            type: "number",
            size: "small",
            modelValue: _ctx.newNote.duation,
            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.newNote.duation) = $event)),
            placeholder: "مدت زمان",
            loading: _ctx.loadingSearchUser
          }, null, 8, ["modelValue", "loading"])
        ]),
        _createElementVNode("div", _hoisted_129, [
          _createVNode(_component_el_button, {
            size: "small",
            class: "m-auto",
            type: "primary",
            onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.updateTodo(_ctx.newNote), (_ctx.dialogVisible5 = false)))
          }, {
            default: _withCtx(() => [
              _hoisted_130
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 512))
}